import { environment } from '@environments/environment';

const getTranslatumHost = (): string => {
  if (environment.product === 'p1012') {
    return 'https://translation-manager-app.s3.eu-central-1.amazonaws.com';
  }
  return 'https://translation-manager-app.s3.eu-central-1.amazonaws.com';
};

const getTranslatumEnvSegment = (): string => {
  // prod ortamında 'prod', diğer tüm ortamlarda 'test'
  return environment.production ? 'prod' : 'test';
};

export const translatumApiUrl = `${getTranslatumHost()}/${getTranslatumEnvSegment()}/website/`;
